import { observer } from "mobx-react-lite";
import useNavigateToLeaseComp from '../../hooks/useNavigateToLeaseComp';
import useOpenSelectedItem from '../../hooks/useOpenSelectedItem';
import LeaseCompIcon from '../icons/LeaseCompIcon';
import styles from '../InfoWithIconAndNavigation.module.css';
import LeaseCompInfo, { ILeaseCompInfoProps } from "./LeaseCompInfo";

function LeaseCompInfoWithIconAndNavigation({ id, pipedriveCompanyId, address, totalRent, parcelSizeAcres, buildingSize, className, onClick, index }: ILeaseCompInfoWithIconAndNavigationProps) {
    const navigateToLeaseComp = useNavigateToLeaseComp();

    const click = () => {
        onClick && onClick();
        navigateToLeaseComp(id);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <LeaseCompIcon color="#25479A" className={styles.icon} />
            <LeaseCompInfo
                pipedriveCompanyId={pipedriveCompanyId}
                address={address}
                totalRent={totalRent}
                parcelSizeAcres={parcelSizeAcres}
                buildingSize={buildingSize}
            />
        </div>
    );
}

interface ILeaseCompInfoWithIconAndNavigationProps extends ILeaseCompInfoProps {
    id: number;
    index?: number;
}

export default observer(LeaseCompInfoWithIconAndNavigation);